export const userVids = [
  { value: 1, label: "Телефон" },
  { value: 2, label: "Почта" },
  { value: 3, label: "ВК" },
]

export const userVidRender = value => userVids.find(i => i.value === value)?.label;

export const progKeysStatuses = [
  { value: 0, label: "Свободен" },
  { value: 1, label: "Отправлен" },
  { value: 2, label: "Активирован" },
  { value: 3, label: "Заморожен" },
  { value: 4, label: "Предактивирован" },
  { value: 5, label: "Закрыт" },
]

export const progKeysStatusRender = value => progKeysStatuses.find(i => i.value === value)?.label;

export const tasks = [
  { value: 1, label: "Замеры" },
  { value: 2, label: "Монтажи" },
  { value: 3, label: "Установка откосов" },
  { value: 4, label: "Рекламации" },
  { value: 5, label: "Производство" },
]

export const tokenVids = [
  { value: 0, label: " " },
  { value: 1, label: "Телеграмм" },
  { value: 2, label: "WhatsApp" },
  { value: 3, label: "Max" },
  { value: 4, label: "СМС" },
  { value: 201, label: "Чат на сайте" },
  { value: 151, label: "SIP Телефон" },
]

export const tokenVidsLabel = value => tokenVids.find(i => i.value === value)?.label;

export const messageStatuses = [
  { value: -1, label: "Ошибка отправки" },
  { value: 0, label: "Новое сообщение" },
  { value: 5, label: "Отправка" },
  { value: 1, label: "Отправлено" },
  { value: 2, label: "Доставлено" },
  { value: 3, label: "Прочитано" },
]

export const messageStatusesRender = value => messageStatuses.find(i => i.value === value)?.label;

export const messageDirections = [
  { value: 1, label: "Входящее" },
  { value: -1, label: "Исходящее" },
]

export const messageDirectionsRender = value => messageDirections.find(i => i.value === value)?.label;

// Виды программ
export const softVids = [
  { value: 1, label: "ИТ Окна Производство" },
  { value: 2, label: "ИТ Окна" },
  { value: 11, label: "Оздоровительный центр" },
  { value: 12, label: "Медицина" },
  { value: 13, label: "Пансионат" },
  { value: 14, label: "Фитнес" },
  { value: 15, label: "Спорткомплекс" },
  { value: 21, label: "Облако" },
]

export const softVidsRender = value => softVids.find(i => i.value === value)?.label;

// Статусы резервных копий
export const backupStatuses = [
  { value: -2, label: "Ошибка передачи", color: "red", },
  { value: -1, label: "Ошибка проверки", color: "red", },
  { value:  0, label: "Зарезервировано", color: "yellow", },
  { value:  2, label: "Передача завершена", color: "green", },
  { value:  3, label: "Начало проверки", color: "green", },
  { value:  4, label: "Данные проверены", color: "green", },
  { value:  5, label: "Перемещено в архив", color: "blue", },
  { value:  6, label: "Удалено из архива", color: "blue", },
]